import { render } from "./clothCard.vue?vue&type=template&id=e2990006&scoped=true&ts=true"
import script from "./clothCard.vue?vue&type=script&lang=ts"
export * from "./clothCard.vue?vue&type=script&lang=ts"

import "./clothCard.vue?vue&type=style&index=0&id=e2990006&lang=scss&scoped=true"

import exportComponent from "G:\\IT\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2990006"]])

export default __exports__